import React from 'react';

import * as A from 'fp-ts/Array';
import { pipe } from 'fp-ts/lib/function';
import { MatchPlayerFragment } from '../../generated/graphql';

import { PlayerAvailabilities } from '../../utils/makeAvailabilityMap';
import { AvailabilityStatusDot } from '../../components/AvailabilityStatus';
import { byName } from '../../utils/sorting';
import { PlayerNameWithAvatar } from './components/PlayerNameWithAvatar';

interface Props {
  players: MatchPlayerFragment[];
  availabilities: PlayerAvailabilities;
  isSignedIn: boolean;
}

export const SquadList: React.FunctionComponent<Props> = ({
  players,
  availabilities,
  isSignedIn,
}) => {
  return (
    <ul className="flex-1">
      {pipe(
        players,
        A.sort(byName),
        A.map((player) => {
          return (
            <li key={player.id} className="flex items-center py-1">
              <PlayerNameWithAvatar player={player} linkToPlayer={isSignedIn} />

              <AvailabilityStatusDot
                status={availabilities[player.id]}
                className="ml-2"
              />
            </li>
          );
        }),
      )}
    </ul>
  );
};
